import {
  createFrontendPlugin,
  PageBlueprint,
  PluginHeaderActionBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiPuzzle2Line } from '@remixicon/react';
import { rootRouteRef } from './routes';

const edgeFabricOnboardingPage = PageBlueprint.make({
  params: {
    title: 'Edge Fabric Onboarding',
    icon: <RiPuzzle2Line />,
    path: '/onboarding/edge-fabric',
    routeRef: rootRouteRef,
    loader: () => import('./app').then(m => <m.EdgeFabricOnboardingRoot />),
  },
});

export const headerActions = PluginHeaderActionBlueprint.make({
  params: defineParams =>
    defineParams({
      loader: () =>
        import('./components/header-actions').then(m => <m.HeaderActions />),
    }),
});

export const edgeFabricOnboardingPlugin = createFrontendPlugin({
  pluginId: 'edge-fabric',
  extensions: [edgeFabricOnboardingPage, headerActions],
  routes: {
    root: rootRouteRef,
  },
});
